"use strict";

const loginBtn = document.querySelector(".login");
const overlay = document.querySelector(".overlay");
const model = document.querySelector(".model");
const closeModel = document.querySelector(".btn--close__model");
const loginIcon = document.querySelector(".login-icon");
const nav = document.querySelector(".nav");
const getStartBtns = document.querySelectorAll(".btn");

//model Window
const modelShow = function () {
  model.classList.remove("hidden");
  overlay.classList.remove("hidden");
};

const hideModel = function () {
  model.classList.add("hidden");
  overlay.classList.add("hidden");
};

loginIcon.addEventListener("click", modelShow);

loginBtn.addEventListener("click", modelShow);

closeModel.addEventListener("click", hideModel);

overlay.addEventListener("click", hideModel);

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && !model.classList.contains("hidden")) {
    hideModel();
  }
});

//SCROLL EFFECT
// document.querySelectorAll(".nav--link").forEach(function (el) {
//   el.addEventListener("click", function (e) {
//     e.preventDefault();
//     const id = this.getAttribute("href");
//     console.log(id);
//     document.querySelector(id).scrollIntoView({
//       behavior: "smooth",
//     });
//   });
// });

document.querySelector(".nav-item").addEventListener("click", function (e) {
  e.preventDefault();
  if (e.target.classList.contains("nav--link")) {
    console.log(e.target);
    const id = e.target.getAttribute("href");
    console.log(id);
    document.querySelector(id).scrollIntoView({
      behavior: "smooth",
    });
  }
});

const mouseEvent = function (e) {
  if (e.target.classList.contains("nav--link")) {
    const link = e.target;
    const sibling = link.closest(".nav").querySelectorAll(".nav--link");
    const logo = link.closest(".nav").querySelector("img");

    sibling.forEach((el) => {
      if (el !== link) el.style.opacity = this;
    });
    logo.style.opacity = this;
  }
};

nav.addEventListener("mouseover", mouseEvent.bind(0.5));

nav.addEventListener("mouseout", mouseEvent.bind(1));

//scroll translate Section
const allSections = document.querySelectorAll(".section");

const revealSectin = function (entries, observer) {
  const [entry] = entries;
  if (!entry.isIntersecting) return;
  entry.target.classList.remove("section--hidden");
  observer.unobserve(entry.target);
};

const sectionObserver = new IntersectionObserver(revealSectin, {
  root: null,
  threshold: 0.15,
});

allSections.forEach((section) => {
  section.classList.add("section--hidden");
  sectionObserver.observe(section);
});

getStartBtns.forEach((btn) => {
  btn.addEventListener("click", function () {
    location.href = "./price.html";
  });
});
